'use client';

import { IconCheck } from '@tabler/icons-react';

interface ChecklistItem {
  text: string;
}

interface LandingPageChecklistProps {
  heading?: string;
  subtitle?: string;
  items?: ChecklistItem[];
}

export const LANDING_PAGE_CHECKLIST_COMPONENT_NAME = 'LandingPageChecklist';

export const LandingPageChecklist = ({
  heading = 'Ever found yourself looking for a different type of insurance?',
  subtitle = "One that's flexible and gives you stress-free driving when you're:",
  items = [],
}: LandingPageChecklistProps) => {
  return (
    <section className="bg-background-200 py-[32px]">
      <div className="tc-container">
        <div className="mx-auto flex flex-col items-center gap-[32px]">
          {/* Heading + Subtitle */}
          {(heading || subtitle) && (
            <div className="flex flex-col md:items-center md:text-center">
              {heading && <h2 className="tc-headline mb-0 max-w-[856px] md:mx-auto md:text-center">{heading}</h2>}
              {subtitle && (
                <p className="text-dark-200 mt-4 mb-0 text-[18px] leading-[1.2] font-bold md:text-[23px]">{subtitle}</p>
              )}
            </div>
          )}

          {/* Checklist Card */}
          {items.length > 0 && (
            <div className="border-background-400 shadow-tc w-full rounded-lg border bg-white p-[24px]">
              <ul className="mt-0 flex list-none flex-col gap-[16px] pl-0">
                {items.map((item, index) => (
                  <li key={index} className="my-0 flex items-start gap-[16px]">
                    <IconCheck size={24} stroke={2} className="text-dark shrink-0" aria-hidden="true" />
                    <span className="text-dark-200 text-[16px] leading-[1.4] font-medium md:text-[18px]">
                      {item.text}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
